import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip
} from '@mui/material';

const InventoryReport = ({ data }) => (
  <Box>
    <Typography variant="h5" gutterBottom>Inventory Report</Typography>
    
    <Grid container spacing={3} sx={{ mb: 4 }}>
      <Grid item xs={12} sm={6} md={3}>
        <Card>
          <CardContent>
            <Typography color="textSecondary" gutterBottom>Total Items</Typography>
            <Typography variant="h5">{data.summary.totalItems}</Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Card>
          <CardContent>
            <Typography color="textSecondary" gutterBottom>Total Value</Typography>
            <Typography variant="h5">${data.summary.totalValue.toFixed(2)}</Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Card>
          <CardContent>
            <Typography color="textSecondary" gutterBottom>Low Stock Items</Typography>
            <Typography variant="h5" color="warning.main">
              {data.summary.totalLowStock}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Card>
          <CardContent>
            <Typography color="textSecondary" gutterBottom>Categories</Typography>
            <Typography variant="h5">{Object.keys(data.summary.byType).length}</Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>

    <Typography variant="h6" gutterBottom>Inventory by Category</Typography>
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Category</TableCell>
            <TableCell align="right">Count</TableCell>
            <TableCell align="right">Total Value</TableCell>
            <TableCell align="right">Low Stock</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.entries(data.summary.byType).map(([type, stats]) => (
            <TableRow key={type}>
              <TableCell>{type}</TableCell>
              <TableCell align="right">{stats.count}</TableCell>
              <TableCell align="right">${stats.totalValue.toFixed(2)}</TableCell>
              <TableCell align="right">
                <Chip 
                  label={stats.lowStock}
                  color={stats.lowStock > 0 ? 'warning' : 'success'}
                  size="small"
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </Box>
);

export default InventoryReport;
